import moment from "moment/moment";

    export function formatDateTime(date, format = "date") {
    if (!date) return "-";
  
    const momentDate = moment(date);
  
    switch (format) {
      case "date":
        return momentDate.format("MMM DD, YYYY");
      case "datetime":
        return momentDate.format("MMM DD, YYYY HH:mm");
      case "time":
        return momentDate.format("HH:mm:ss");
      case "short":
        return momentDate.format("MMM DD");
      case "full":
        return momentDate.format("MMMM DD, YYYY [at] HH:mm");
      case "relative":
        return momentDate.fromNow();
      default:
        return momentDate.format("MMM DD, YYYY");
    }
  }

  export const sectorOptions = [
    "Communication Services",
    "Consumer Discretionary",
    "Consumer Staples",
    "Energy",
    "Financials",
    "Health Care",
    "Industrials",
    "Information Technology",
    "Materials",
    "Real Estate",
    "Utilities",
  ];
  export const assetOptions = [
    "ADR",
    "Common Stock",
    "Convertible Bond",
    "Corporate Bond",
    "ETF",
    "Future",
    "Government Bond",
    "MLP",
    "Money Market",
    "Mutual Fund",
    "Option",
    "REIT",
    "Swap",
  ];